import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import App from './App';
import * as serviceWorker from './registerServiceWorker';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
//import config from './auth_config.json';
import history from './utils/history';
import PortalAuthProvider from './auth/PortalAuthProvider';

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState) => {
  history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


ReactDOM.render(
  <PortalAuthProvider onRedirectCallback={onRedirectCallback}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </PortalAuthProvider>,
  document.getElementById('root'),
  document.getElementById('PhishCloudExtenstionActive')
);

serviceWorker.unregister();

//import 'bootstrap/dist/css/bootstrap.css';
//import React from 'react';
//import ReactDOM from 'react-dom';
//import { BrowserRouter } from 'react-router-dom';
//import App from './App';
//import registerServiceWorker from './registerServiceWorker';

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const rootElement = document.getElementById('root');

//ReactDOM.render(
//  <BrowserRouter basename={baseUrl}>
//    <App />
//  </BrowserRouter>,
//  rootElement);

//registerServiceWorker();
